const role = {
  'owner' : 'owner',
  'viewer' : 'viewer',
  'contributor' : 'contributor'
}
export default role;
